import { BookForOthers } from './BookForOthers';

export default BookForOthers;